'use client'

import { usePathname, useRouter } from 'next/navigation'
import { Drawer, DrawerBody, DrawerContent, DrawerHeader } from '@heroui/drawer'
import { IconLine } from "@/components/IconLine"
import { ChevronLeftIcon } from "@heroicons/react/24/outline"
import Link from "next/link"
import { Button } from "@heroui/react"

export default function DrawerPortal({ children, header }: { children: React.ReactNode, header?: React.ReactNode }) {
    const pathname = usePathname()
    const router = useRouter()
    const isOpen = pathname !== '/'

    return (
        <Drawer
            isOpen={isOpen}
            onClose={() => router.push('/')}
            placement="right"
            size="5xl"
            hideCloseButton
        >
            <DrawerContent>
                <DrawerHeader className="flex w-full items-center justify-between pb-0">
                    <Button isIconOnly as={Link} href="/" variant="light" color="secondary" className="-ml-2"><ChevronLeftIcon height={36} /></Button>
                    {header && <div className="ml-3">{header}</div>}
                </DrawerHeader>
                <DrawerBody className="p-0">
                    {children}
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}
